/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, ButtonGroup, Card, Col, Collapse, Container, Form, Row, ToggleButton } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { e休日区分 } from "../../../constant/enum/master"
import { e社員区分 } from "../../../constant/enum/syain"
import { メニューコード } from "../../../constant/menuCode"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除, 画面ロック開始 } from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import SyukkinboService from "../../../service/attendance/syukkinbo_v2/syukkinboService"

import Decimal from "decimal.js"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import { e記号 } from "../../../constant/enum/frontend"
import { T勤怠区分, e勤怠区分 } from "../../../constant/enum/unko"
import { TSyukkinboListGetReq, TSyukkinboListGetRes } from "../../../service/attendance/syukkinbo_v2/TZyomuinSyukkinbo"
import BusyoService from "../../../service/master/busyo/busyoService"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import dateUtil from "../../../ts/util/dateUtil"
import { TWijmoCellTemplateContext, TWijmoComboBox } from "../../../type/wijmoComponents"
import { T勤怠リスト } from "../ZyomuinSyukkinbo_v2/ZyomuinSyukkinbo"
import { e労務警告区分 } from "../ZyomuinSyukkinbo_v2/zyomuinSyukkinboUtil"

/**
 * 乗務員出勤簿一覧
 * @returns
 */
const ZyomuinSyukkinboList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ref
  const ref明細ヘッダーフォーマットフラグ = useRef<boolean>(false)
  const ref年月 = useRef<string>(eigyobi)
  const ref日曜日 = useRef<string>()
  const ref日数 = useRef<number>(0)

  // 休日対応
  let refHolidayList = useRef<Array<{ 休日: string }>>([])
  // 所定休日対応
  let refSyoteidayList = useRef<Array<{ 休日: string }>>([])

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinSyukkinboList_GridId"

  //#region [method]

  /**
   * 検索条件の年月から対象月の日数を返却
   */
  const getLastDay = () => {
    const endDate = dayjs(ref年月.current).add(1, "month").date(0).toDate()
    const lastDay = dayjs(endDate).format("DD")
    return parseInt(lastDay)
  }

  /**
   * レイアウト（列表示設定）適用後の日付列の表示可否再適用
   *
   * 日付列の表示可否は「表示中の年月の日数」で決まるため、
   * ユーザーが保存したレイアウトやデフォルトレイアウトに含まれる visible をそのまま復元すると、
   * レイアウト保存時の年月の日数が引き継がれてしまう（例: 30日の月で保存 → 31日列が非表示のまま）。
   * そのためレイアウト適用後は日付列だけ表示中の年月の日数で上書きする。
   */
  const applyDayColumnVisible = (grid: wjcGrid.FlexGrid) => {
    const 日数 = getLastDay()
    grid.deferUpdate(() => {
      grid.columns.forEach((column) => {
        const matched = column.binding?.match(/^day_([0-9]+)_[0-9]+$/)
        if (!matched) return
        column.visible = parseInt(matched[1]) <= 日数
      })
    })
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TSyukkinboListGetRes>, pageSize: number, 表示切替: number) => {
    // 当月分の日数リスト
    let dList: number[] = []
    // 当月の最大日数取得
    let cnt = getLastDay()
    // 当月の日数分を日数リストへ格納
    for (let k = 1; k < cnt + 1; k++) {
      dList.push(k)
    }

    // 表示切替に対応するため、Calcフィールドとして日付Column作成
    let 日付リスト: {
      [key: string]: (i: T出勤簿リスト) => string
    } = {}

    dList.forEach((element: number) => {
      // 勤怠表示時
      日付リスト[`day_${element}_1`] = (i: T出勤簿リスト) => {
        const 当日勤怠List = i.勤怠リスト?.filter((k) => {
          // 勤務日から日付のみ取得
          let d = parseInt(dayjs(k.勤務日).format("D"))
          return element === d
        })
        if (当日勤怠List == null || 当日勤怠List.length === 0) {
          return ""
        }
        // 勤怠表示は先頭
        const 当日勤怠 = 当日勤怠List[0]

        switch (当日勤怠.勤怠区分コード as T勤怠区分) {
          case e勤怠区分.出勤:
            // 終業時間をすべて合算し、時間により記号が変化
            const 終業時間総計 = 当日勤怠List.reduce((ms, a) => ms.plus(a.勤務時間 ?? 0), new Decimal(0)).toNumber()

            const hourMilliSeconds = 1000 * 60 * 60
            if (終業時間総計 < hourMilliSeconds * 2) {
              return e記号.黒三角
            } else if (終業時間総計 < hourMilliSeconds * 4) {
              return e記号.三角
            } else if (終業時間総計 < hourMilliSeconds * 6) {
              return e記号.黒丸
            }
            return e記号.丸
          case e勤怠区分.有給休暇:
            return "有"
          case e勤怠区分.午前半休:
            return "A"
          case e勤怠区分.午後半休:
            return "P"
          case e勤怠区分.特別休暇:
            return "特"
          case e勤怠区分.代休:
            return "代"
          case e勤怠区分.振替休日:
            return "振"
          case e勤怠区分.欠勤:
            return "欠"
          case e勤怠区分.所定休日:
            return "所"
          case e勤怠区分.所定出勤:
            return "出"
          case e勤怠区分.育介休暇:
            return "育"
          case e勤怠区分.育介半休:
            return "半"
          default:
            return ""
        }
      }

      // 警告表示時
      日付リスト[`day_${element}_2`] = (i: T出勤簿リスト) => {
        const 当日勤怠List = i.勤怠リスト?.filter((k) => {
          // 勤務日から日付のみ取得
          let d = parseInt(dayjs(k.勤務日).format("D"))
          return element === d
        })
        if (当日勤怠List == null || 当日勤怠List.length === 0) {
          return ""
        }
        // 先頭より確認していき一番初めに出現した番号を表示
        let 番号 = ""
        for (let index = 0; index < 当日勤怠List.length; index++) {
          const 当日勤怠 = 当日勤怠List[index]
          if (当日勤怠.勤怠警告6 === 1) {
            番号 = e労務警告区分.連続走行時間4時間以上
            break
          }
          if (当日勤怠.勤怠警告5 === 1) {
            // 拘束時間を確認し14時間以上の場合に31
            const 拘束時間 = !Number.isNaN(当日勤怠.拘束時間) ? parseInt(当日勤怠.拘束時間 ?? "0") : 0
            const hourMilliSeconds = 1000 * 60 * 60
            if (hourMilliSeconds * 14 < 拘束時間) {
              番号 = e労務警告区分.拘束時間14時間超過
              break
            }
          }
          if (当日勤怠.勤怠警告4 === 1) {
            番号 = e労務警告区分.休息3時間未満
            break
          }

          if (当日勤怠.勤怠警告3 === 1) {
            番号 = e労務警告区分.電話点呼時中間点呼未存在
            break
          }
          if (当日勤怠.勤怠警告1 === 1) {
            番号 = e労務警告区分.出勤打刻未存在かつデジタコ出庫存在
            break
          }
          if (当日勤怠.勤怠警告5 === 1) {
            番号 = e労務警告区分.拘束時間13時間超過
            break
          }
          if (当日勤怠.勤怠警告2 === 1) {
            番号 = e労務警告区分.出勤打刻存在かつ退勤打刻未存在
            break
          }
        }
        return 番号
      }
    })

    return new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        str休憩時間: (d: T出勤簿一覧) => dateUtil.toTimeSpanString(d.勤務時間),
        str休息時間: (d: T出勤簿一覧) => dateUtil.toTimeSpanString(d.休息時間),
        str拘束時間: (d: T出勤簿一覧) => dateUtil.toTimeSpanString(d.拘束時間),
        str勤務時間: (d: T出勤簿一覧) => dateUtil.toTimeSpanString(d.勤務時間),
        str残業時間: (d: T出勤簿一覧) => dateUtil.toTimeSpanString(d.残業時間),
        str深夜時間: (d: T出勤簿一覧) => dateUtil.toTimeSpanString(d.深夜時間),
        str休出時間: (d: T出勤簿一覧) => dateUtil.toTimeSpanString(d.休出時間),
        padding社員コード: (data: T出勤簿リスト) =>
          data.社員コード != null && data.社員コード !== "" ? data.社員コード?.padStart(4, "0") : "9999",
        ...日付リスト,
      },
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyukkinboListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    flexGrid?.select(-1, -1)

    let currentSearchCondition: TSyukkinboListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(createDisplaySearchCondition(currentSearchCondition))

    try {
      const res = await new SyukkinboService().zyomuinGetList(currentSearchCondition)

      const sortedResData = res.data.sort((a, b) => {
        if (a.社員コード.padStart(4, "0") > b.社員コード.padStart(4, "0")) return 1
        if (a.社員コード.padStart(4, "0") < b.社員コード.padStart(4, "0")) return -1
        return 0
      })

      setGridData({
        data: createCollectionView(sortedResData, pageSize, 1),
      })

      const kyuzituRes = await new KyuzituService().getList({
        検索年: currentSearchCondition.年月,
      })

      kyuzituRes.data
        .filter((d) => d.休日区分コード === e休日区分.会社休日)
        .forEach((i) => {
          refHolidayList.current.push({
            休日: i.休日日付,
          })
        })
      const syoteiRes = kyuzituRes.data.filter(
        (d) => d.休日区分コード === e休日区分.所定休日 || d.休日区分コード === e休日区分.祝日,
      )
      syoteiRes.forEach((i) => {
        refSyoteidayList.current.push({
          休日: i.休日日付,
        })
      })

      // formatItemを入れなおすためフラグを切り替え
      ref明細ヘッダーフォーマットフラグ.current = false
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyukkinboListGetReq = queryString.parse(location.search)
    set年月(query.年月)
    set部所コード(query.部所コード ?? "")
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyukkinboListGetReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所コード: 部所コード ?? undefined,
      社員区分コード: e社員区分.乗務員,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TSyukkinboListGetReq) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    const disp部所 = 部所ItemSource?.find((i) => i.部所コード === searchCondition.部所コード)
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: disp部所 ? `${disp部所.部所コード} ${disp部所.部所略称}` : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize, 表示切替)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月(eigyobi)
    ref年月.current = eigyobi
    ref日数.current = 0
    ref明細ヘッダーフォーマットフラグ.current = false

    set部所コード("")
    set部所(undefined)
    set部所ItemSource(undefined)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダの設定
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // 対象月の日数取得
    let cnt = getLastDay()

    if (e.panel === f.cells) {
      const col = e.getColumn()

      // 勤務
      if (col.binding?.match(/day_[0-9]+_1/)) {
        const data = f.getCellData(e.row, e.col, false)
        wjCore.toggleClass(e.cell, "bg-red", false)
        wjCore.toggleClass(e.cell, "bg-yellow", false)
        wjCore.toggleClass(e.cell, "text-black", false)
        wjCore.toggleClass(e.cell, "text-pink", false)
        wjCore.toggleClass(e.cell, "text-green", false)
        wjCore.toggleClass(e.cell, "text-blue", false)
        wjCore.toggleClass(e.cell, "text-red", false)
        wjCore.toggleClass(e.cell, "text-brown", false)

        switch (data) {
          case e記号.黒三角:
          case e記号.三角:
          case e記号.黒丸:
          case e記号.丸:
            wjCore.toggleClass(e.cell, "text-black", true)
            break
          case "有":
          case "A":
          case "P":
            wjCore.toggleClass(e.cell, "text-red", true)
            break
          case "特":
            wjCore.toggleClass(e.cell, "text-green", true)
            break
          case "所":
            wjCore.toggleClass(e.cell, "text-blue", true)
            break
          case "育":
          case "半":
            wjCore.toggleClass(e.cell, "text-brown", true)
            break
          case "振":
          case "代":
          case "欠":
            wjCore.toggleClass(e.cell, "text-red", true)
            break
          default:
            break
        }
      }
      // 警告
      if (col.binding?.match(/day_[0-9]+_2/)) {
        const data = f.getCellData(e.row, e.col, false)
        wjCore.toggleClass(e.cell, "bg-red", false)
        wjCore.toggleClass(e.cell, "bg-yellow", false)
        wjCore.toggleClass(e.cell, "text-black", false)
        wjCore.toggleClass(e.cell, "text-pink", false)
        wjCore.toggleClass(e.cell, "text-green", false)
        wjCore.toggleClass(e.cell, "text-blue", false)
        wjCore.toggleClass(e.cell, "text-red", false)
        wjCore.toggleClass(e.cell, "text-brown", false)
        wjCore.toggleClass(e.cell, "fw-bold", false)

        switch (data as (typeof e労務警告区分)[keyof typeof e労務警告区分]) {
          case e労務警告区分.出勤打刻未存在かつデジタコ出庫存在:
          case e労務警告区分.電話点呼時中間点呼未存在:
          case e労務警告区分.休息3時間未満:
          case e労務警告区分.拘束時間14時間超過:
          case e労務警告区分.連続走行時間4時間以上:
            wjCore.toggleClass(e.cell, "bg-red", true)
            wjCore.toggleClass(e.cell, "fw-bold", true)
            break
          case e労務警告区分.出勤打刻存在かつ退勤打刻未存在:
          case e労務警告区分.拘束時間13時間超過:
            wjCore.toggleClass(e.cell, "bg-yellow", true)
            wjCore.toggleClass(e.cell, "fw-bold", true)
            break
          default:
            break
        }
      }

      //残業時間項目の警告
      switch (col.binding as keyof T勤怠リスト) {
        case "str残業時間":
          const data = f.getCellData(e.row, e.col, false)
          const colMilliSecond = dateUtil.toMilliseconds(data)
          const hour60 = 60 * 60 * 60 * 1000
          const hour80 = 80 * 60 * 60 * 1000

          wjCore.toggleClass(e.cell, "bg-amber", hour60 <= colMilliSecond && colMilliSecond < hour80)
          wjCore.toggleClass(e.cell, "bg-red", hour80 <= colMilliSecond)
          break
      }
    }

    // ループをフラグで制御？
    if (ref明細ヘッダーフォーマットフラグ.current) return

    let columnHeaders = f.columnHeaders

    // Date変換
    let targetDate = eigyobi
    if (ref年月.current != null) targetDate = ref年月.current
    // 対象の年月までを設定する
    let ymDate = dayjs(targetDate).format("YYYYMM")

    // ヘッダーstart
    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      if (c.binding != null) {
        switch (c.binding as keyof T出勤簿一覧) {
          case "部所略称":
          case "社員コード":
          case "社員氏名":
            columnHeaders.setCellData(0, index, "所属")
            break
          case "str勤務時間":
          case "str残業時間":
          case "str深夜時間":
          case "str休出時間":
          case "str拘束時間":
            columnHeaders.setCellData(0, index, "就労時間")
            break
          case "出勤日数":
          case "休出日数":
          case "特休日数":
          case "有休日数":
          case "振替日数":
          case "代休日数":
          case "欠勤日数":
          case "育介日数":
            columnHeaders.setCellData(0, index, "就労日数")
            break
          default:
            columnHeaders.setCellData(0, index, c.header)
            break
        }
      }
      // 日付部分
      // 日数分の設定
      for (let i = 1; i < cnt + 1; i++) {
        let day = "day_" + i
        if (c.binding?.startsWith(day)) {
          // 対象月のYYYYMMにDD部分を合わせる
          let target = ymDate + i
          // 曜日を取得
          let str = dayjs(target).format("ddd")
          columnHeaders.setCellData(0, index, i) // 日付
          columnHeaders.setCellData(1, index, str) // 曜日

          // 休日カレンダー判定
          let sundayCssClass = "holiday-color"
          let holidayCssClass = "syukkinbo-holiday-color"

          // css設定済みフラグ
          let isCssClass = false

          // columnの日付生成
          const ret = ("00" + i).slice(-2) // 0埋め
          const colDate = dayjs(targetDate).format("YYYY/MM") + "/" + ret

          const tmp曜日 = dayjs(colDate).format("ddd")
          const is休日 = refHolidayList.current.find((d) => dayjs(d.休日).format("YYYY/MM/DD") === colDate)

          const is所定 = refSyoteidayList.current.find((d) => dayjs(d.休日).format("YYYY/MM/DD") === colDate)

          // 列の日付が休日だった場合、CSSを設定する
          const columnIndex = i + HeaderEndColumnIndex
          if (tmp曜日 === ref日曜日.current && !isCssClass) {
            columnHeaders.columns[columnIndex].cssClassAll = sundayCssClass
            isCssClass = true
          } else if (is休日 && !isCssClass) {
            columnHeaders.columns[columnIndex].cssClassAll = sundayCssClass
            isCssClass = true
          } else if (is所定 && !isCssClass) {
            columnHeaders.columns[columnIndex].cssClassAll = holidayCssClass
            isCssClass = true
          } else {
            columnHeaders.columns[columnIndex].cssClassAll = ""
          }
        }
      }

      c.allowMerging = true
      c.align = "center"
    })

    // フォーマットのループ制御
    ref明細ヘッダーフォーマットフラグ.current = true
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(15)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize, 1),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年月, set年月] = useState<string | null>()

  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [表示切替, set表示切替] = useState<number>(1)
  const [excel出力切替, setExcel出力切替] = useState(1)
  const [excelIncludeColumns, setExcelIncludeColumns] = useState<string[]>()

  //#region comboboxState
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<T部所マスタ["部所コード"], T部所マスタ> | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  const [isComboboxItemInitialised, setIsComboboxItemInitialised] = useState(false)
  //#endregion

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `出勤簿一覧`
    // 初期表示生成のため画面ロック
    ref日数.current = getLastDay()

    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (!年月) return
    ref年月.current = 年月

    // 対象月の日数取得
    ref日数.current = getLastDay()
  }, [年月])

  useEffect(() => {
    Promise.all([new BusyoService().getList({}), new KyuzituService().getList({ 検索年: eigyobi })]).then(
      ([部所ListRes, 休日マスタRes]) => {
        set部所ItemSource(部所ListRes.data)

        const kaisyaKyujituRes = 休日マスタRes.data.filter((d) => d.休日区分コード === e休日区分.会社休日)
        kaisyaKyujituRes.forEach((i) => {
          refHolidayList.current.push({
            休日: i.休日日付,
          })
        })
        const syoteiRes = 休日マスタRes.data.filter(
          (d) => d.休日区分コード === e休日区分.祝日 || d.休日区分コード === e休日区分.所定休日,
        )
        syoteiRes.forEach((i) => {
          refSyoteidayList.current.push({
            休日: i.休日日付,
          })
        })

        ref日曜日.current = "日"
        ref明細ヘッダーフォーマットフラグ.current = false
        setIsComboboxItemInitialised(true)
      },
    )
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 部所ComboBox && isComboboxItemInitialised) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 部所ComboBox, isComboboxItemInitialised])

  useEffect(() => {
    setExcelIncludeColumns(excel出力切替 === 1 ? 基本情報カラム名List : undefined)
  }, [excel出力切替])

  //#endregion

  const dayNumbers = []
  for (let index = 1; index <= 31; index++) {
    dayNumbers.push(index)
  }

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員出勤簿一覧(新)</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon icon={accordionController ? faChevronDown : faChevronUp} size={"1x"} />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                value={年月}
                                setValue={set年月}
                                isRequired
                                placeholder="年月"
                                defaultValue={eigyobi}
                                autoFocus={true}
                              />
                            </div>
                            <ComboBox.Busyo
                              placeholder="部所"
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              isAllSelect={true}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel displaySearchCondition={displaySearchCondition} />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={true}
                afterApplyGridLayout={applyDayColumnVisible}
                hasFilter={false}
                excelIncludeColumns={excelIncludeColumns}
                formatItem={formatItem}
                gridProperties={{
                  frozenColumns: 3,
                  allowSorting: wjcGrid.AllowSorting.None,
                  allowDragging: wjcGrid.AllowDragging.None,
                }}
                headerComponent={
                  <div className="d-flex">
                    <ButtonGroup>
                      {表示切替リスト.map((radio, idx, arr) => (
                        <ToggleButton
                          key={idx}
                          id={`radio-${radio.name}`}
                          type="radio"
                          variant={"outline-success"}
                          name="radio"
                          size="lg"
                          className="fs-5"
                          value={radio.value}
                          checked={表示切替 === radio.value}
                          onChange={(e) => set表示切替(parseInt(e.currentTarget.value))}>
                          {radio.name}
                        </ToggleButton>
                      ))}
                    </ButtonGroup>
                    <CheckInput
                      label="Excel出力時に集計のみ出力する"
                      value={excel出力切替}
                      setValue={(v) => setExcel出力切替(v)}
                      type={"checkbox"}
                    />
                    <div className="mt-1 mx-auto">〇：６時間以上、●：４～６時間、△：２～４時間、▲：２時間未満</div>
                    {/* {process.env.REACT_APP_ENVIRONMENT_NAME &&
                      ["検証環境", "ローカル環境(.env.local)"].includes(
                        process.env.REACT_APP_ENVIRONMENT_NAME
                      ) && (
                        <Button
                          variant="warning"
                          onClick={async () => {
                            try {
                              if (
                                window.confirm(
                                  "配送明細も含めてすべての勤怠を作り直します。よろしいですか？"
                                )
                              ) {
                                if (
                                  window.confirm(
                                    "実行すると戻せません。本当によろしいですか？"
                                  )
                                ) {
                                  setIsSearching(true)
                                  await new SyukkinboService().reCreate()
                                  alert("完了！")
                                }
                              }
                            } catch (error) {
                              setAlerts(error)
                            } finally {
                              setIsSearching(false)
                            }
                          }}>
                          再作成
                        </Button>
                      )} */}
                  </div>
                }>
                {/* ここから固定列 Start */}
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  cssClass="text-start"
                  width={120}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  sortMemberPath={"padding社員コード"}
                  cssClass="text-start"
                  width={70}
                  header="社員番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="社員氏名" cssClass="text-start" width={128} header="氏名">
                  {/* TODO:buttonじゃなくてaタグで遷移させたい。別Tab対応も考慮。 */}
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T出勤簿リスト>) => {
                      return (
                        <button
                          className="link-button text-primary"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(location.pathname)
                            const path = util.getMenuPath(メニューコード.勤怠管理.乗務員出勤簿)
                            console.log(path)
                            history.push(
                              `/attendance/zyomuinsyukkinbo/v2/:id/:date`
                                // path[0]
                                .replaceAll(":id", context.item.社員ID.toString())
                                .replaceAll(":date", dayjs(ref年月.current).format("YYYY-MM-DD")),
                            )
                          }}>
                          {context.item.社員氏名}
                        </button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                {/* ここまで固定列 End */}
                {/* 以下スクロール列 */}
                <wjrGrid.FlexGridColumn
                  binding="str勤務時間"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="勤務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="str残業時間"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="残業"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="str深夜時間"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="深夜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="str休出時間"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="休出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="str拘束時間"
                  cssClass="text-end"
                  width={60}
                  format="n0"
                  align="right"
                  header="拘束"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="出勤日数"
                  cssClass="text-end"
                  width={60}
                  format="n0"
                  align="right"
                  header="出勤"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="休出日数"
                  cssClass="text-end"
                  wordWrap={true}
                  width={50}
                  format="n0"
                  align="right"
                  header="休出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="特休日数"
                  cssClass="text-end"
                  format="n0"
                  wordWrap={true}
                  width={50}
                  header="特休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="有休日数"
                  wordWrap={true}
                  cssClass="text-end"
                  format="n1"
                  width={50}
                  header="有休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="振替日数"
                  wordWrap={true}
                  cssClass="text-end"
                  format="n0"
                  width={60}
                  header="振替"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="代休日数"
                  wordWrap={true}
                  cssClass="text-end"
                  format="n0"
                  width={60}
                  header="代休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="欠勤日数"
                  wordWrap={true}
                  cssClass="text-end"
                  format="n0"
                  width={60}
                  header="欠勤"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="育介日数"
                  wordWrap={true}
                  cssClass="text-end"
                  format="n1"
                  width={60}
                  header="育介"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="有休残数"
                  wordWrap={true}
                  cssClass="text-end"
                  format="n1"
                  width={50}
                  header="有休残数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="労務警告数"
                  wordWrap={true}
                  cssClass="text-end"
                  format="n0"
                  width={50}
                  header="労務警告"></wjrGrid.FlexGridColumn>

                {dayNumbers.map((day) => (
                  <wjrGrid.FlexGridColumn
                    key={`day_${day}`}
                    binding={表示切替 === 1 ? `day_${day}_1` : `day_${day}_2`}
                    visible={getLastDay() >= day}
                    wordWrap={true}
                    width={45}
                    header={`${day}日`}></wjrGrid.FlexGridColumn>
                ))}
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

// #region [const]

const HeaderEndColumnIndex = 17

const 表示切替リスト: Array<{ value: number; name: string }> = [
  { value: 1, name: "勤務" },
  { value: 2, name: "警告" },
]

const 基本情報カラム名List: string[] = [
  "部所略称",
  "社員コード",
  "社員氏名",
  "str勤務時間",
  "str残業時間",
  "str深夜時間",
  "str休出時間",
  "str拘束時間",
  "出勤日数",
  "休出日数",
  "特休日数",
  "有休日数",
  "振替日数",
  "代休日数",
  "欠勤日数",
  "育介日数",
  "有休残数",
  "労務警告数",
]

//#endregion

// #region [type]

export type T出勤簿一覧 = TSyukkinboListGetRes & {
  str休憩時間?: string
  str休息時間?: string
  str拘束時間?: string
  str勤務時間?: string
  str残業時間?: string
  str深夜時間?: string
  str休出時間?: string
}

export type T出勤簿リスト = T出勤簿一覧 & {
  行ID: symbol
}

//#endregion

export default ZyomuinSyukkinboList
